__webpack_require__.p = "/Art-in-Residence/";